import React, { memo } from 'react';
import { TouchableOpacity, View } from 'react-native';
import { hitSlopS, rem } from 'design-system';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const DistributionTotalCardContent = ({ total, handleClear }) => {
    const styles = useStyles(styleSet);
    return (<View style={styles.row}>
      <View style={styles.flex}>
        <Text Text-16>
          Remaining: <Text Numbers-16>{100 - total}%</Text>
        </Text>
      </View>

      {total > 0 && (<TouchableOpacity hitSlop={hitSlopS} onPress={handleClear}>
          <Text Text-14 Primary>
            Clear
          </Text>
        </TouchableOpacity>)}
    </View>);
};
const styleSet = createStyleSheets(() => ({
    row: {
        padding: rem(16),
        alignItems: 'center',
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
}));
export default memo(DistributionTotalCardContent);
